<template>
    <section class="bg-white py-20 sm:py-28">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="flex items-end justify-between mb-12">
                <div>
                    <span class="text-xs font-semibold uppercase tracking-widest text-[#A07830]">Programs</span>
                    <h2 class="mt-3 text-3xl sm:text-4xl font-extrabold text-[#17364a] tracking-tight">
                        Courses to Match<br />Your Needs
                    </h2>
                </div>
                <a href="/courses" class="hidden sm:inline-flex items-center text-sm font-semibold text-[#A07830] hover:text-[#17364a] transition-colors group">
                    View All Courses
                    <span class="ml-1 group-hover:translate-x-1 transition-transform">&rarr;</span>
                </a>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                <a
                    v-for="(course, index) in courses"
                    :key="index"
                    :href="`/courses/${course.slug}`"
                    class="group relative overflow-hidden border border-[#E5E5E5] hover:border-[#A07830] transition-colors duration-200"
                >
                    <!-- Image -->
                    <div class="relative overflow-hidden h-52 bg-[#F5F5F5]">
                        <img
                            v-if="images[index % images.length]"
                            :src="images[index % images.length].src"
                            :alt="course.name"
                            class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <!-- Category chip -->
                        <span class="absolute bottom-3 left-3 px-2 py-1 text-xs font-semibold bg-[#A07830] text-white">
                            {{ course.category || 'Course' }}
                        </span>
                    </div>
                    <!-- Content -->
                    <div class="p-5">
                        <h3 class="text-sm font-bold text-[#17364a] mb-1">{{ course.name }}</h3>
                        <p class="text-xs text-gray-500 leading-relaxed">{{ course.description ? course.description.substring(0, 70) + '...' : '' }}</p>
                        <div class="mt-4 flex items-center justify-between">
                            <span class="text-xs text-gray-400">Nobel Academy</span>
                            <span class="text-xs font-semibold text-[#A07830]">Enroll &rarr;</span>
                        </div>
                    </div>
                </a>

                <!-- See More card -->
                <a href="/courses" class="group flex items-center justify-center border border-dashed border-[#E5E5E5] hover:border-[#A07830] transition-colors p-8 min-h-[280px]">
                    <div class="text-center">
                        <div class="text-3xl font-extrabold text-[#E5E5E5] group-hover:text-[#A07830] transition-colors mb-2">&rarr;</div>
                        <div class="text-sm font-semibold text-gray-500 group-hover:text-[#A07830] transition-colors">View All Courses</div>
                    </div>
                </a>
            </div>
        </div>
    </section>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { getFeaturedProducts } from '@/services/productService';

const courses = ref([]);

const images = [
    { alt: 'Science', src: 'images/courses/quran.jpg' },
    { alt: 'Mathematics', src: 'images/courses/tafl.jpg' },
    { alt: 'Language', src: 'images/courses/arabic.jpg' },
    { alt: 'Technology', src: 'images/courses/islamic.jpg' },
];

onMounted(() => {
    getFeaturedProducts()
        .then((response) => { courses.value = response.data; })
        .catch(() => {});
});
</script>
